import { Injectable } from '@angular/core';
import { AppState } from '@get/store/configs/reducers';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { GeneratedSocieteComposantFamilleService } from './societe-composant-famille-generated.service';

@Injectable({
  providedIn: 'root'
})
export class SocieteComposantFamilleService extends GeneratedSocieteComposantFamilleService {
  constructor(store$: Store<AppState>, actions$: Actions) {
    super(store$, actions$);
  }
}
